
import {THREE} from '../../utils/three.js'
import {BLOCK_LIST, GLOBAL_DATA} from './tilesHome.js'
// import PhysicTween from '../../utils/math/PhysicTween.js'
// import BSpline from './../../utils/math/BSpline.js'

// https://github.com/thibauts/b-spline
// const bspline = require('b-spline');

const BASIC_VERTEX_SHADER = require( './../../utils/three/shader/basicVertexShader.glsl' )
const FRAGMENT_SHADER = require( './../../utils/three/shader/progressLoadFragmentShader.glsl' )
const BASIC_FRAGMENT_SHADER = require( './../../utils/three/shader/basicFragmentShader.glsl' )



const TEX_LOADER = new THREE.TextureLoader()


const VIDEOS_FPS = 25


function lerpArr( a, b, val )
{
    return a.map((v1, i) => {
        return v1 * val + b[i] * (1 - val)
    })
}

function easeOutExpo(t, b, c, d)
{
    return c * ( -Math.pow( 2, -10 * t/d ) + 1 ) + b
}

export default class BgHome {

    constructor( canvasElmt, w, h, video, isLoadedCallback, touch )
    {
        // this.height = GLOBAL_DATA.height
        this._touch = touch
        this._mouseX = 0.5
        this._mouseY = 0.5
        this._w = w
        this._h = h

        this._videoList = []
        this._tilesData = []
        // this._camMove = new BSpline(CAM_PATH, 2)

        this.scrollVelocity = 0

        this._camData = {

            scrollPos: { x: 0, y: 0, z: 0 },
            moveRot:   { x: 0, y: 0, z: 0 },
            mousePos:  { x: 0, y: 0, z: 0 },
            mouseRot:  { x: 0, y: 0, z: 0 },

            dist: 300,
            offsetY: 0,
            fov: 45,
            sceneH: 1
        }

        this._moveData = {
            currentScroll: 0,
            prevScroll: 0,
            currentValue: 0
        }

        this._margin = 20
        this._time = 0

        this._isLoadedCallback = isLoadedCallback
        this._initThree(canvasElmt, w, h, video)
        this.resize(w, h)

        this._onMouseMove = this._onMouseMove.bind(this)
        this._onOrientation = this._onOrientation.bind(this)


        if (this._touch && window.DeviceOrientationEvent)
        {
            window.addEventListener('deviceorientation', this._onOrientation, false)
        }

        window.addEventListener('mousemove', this._onMouseMove, false)
    }


    /*
            ┌─────────────────────────────────────────────
            │
            │       PUBLIC METHODS
            │
            └─────────────────────────────────────────────
    */

    resize( w, h )
    {
        this._w = w
        this._h = h

        // https://github.com/mrdoob/three.js/issues/1239
        const aspect = w / h
        const fov = this._camData.fov
        const objH = (GLOBAL_DATA.width - 2 * this._margin) / aspect
        const dist = objH / (2 * Math.tan( fov * Math.PI / 360 ))

        this._camData.dist = dist
        this._camData.offsetY = objH / 2

        if (this._camera)
        {
            this._camera.aspect = aspect
            this._camera.updateProjectionMatrix()
            // this._camera.position.z = dist
            // this._camera.position.y = -objH / 2

            this._camData.scrollPos.y = -objH / 2
            this._camData.scrollPos.z = dist
        }

        if (this._renderer)
        {
            this._renderer.setSize(w, h)
        }

        this.scroll()
    }

    update( dt )
    {
        if (this._renderer)
        {
            this._time += dt

            this._updateCamMouse()
            this._move(dt)
            this._updateIntro(this._time)
            this._updateCamera()


            const tilesData = this._tilesData
            for (let i = 0, l = tilesData.length; i < l; i++)
            {
                const tileData = tilesData[i]
                if (tileData.visible && tileData.update !== null)
                {
                    tileData.update(dt)
                }
            }


            this._composer.render(0.01)
        }
    }

    _updateIntro( time )
    {
        const duration = 6000
        const distance = 800
        if (time < duration)
        {
            const v = easeOutExpo( time, -distance, distance, duration )
            for (const tileData of this._tilesData)
            {
                const mesh = tileData.mesh
                if (tileData.visible)
                {
                    mesh.position.y += v
                }
            }
        }
    }

    _updateCamera()
    {

        if (this._camera)
        {
            const scrollPos = this._camData.scrollPos
            const mousePos = this._camData.mousePos

            const moveRot = this._camData.moveRot
            const mouseRot = this._camData.mouseRot

            this._camera.position.set(
                scrollPos.x + mousePos.x,
                scrollPos.y + mousePos.y,
                scrollPos.z + mousePos.z,
            )

            this._camera.rotation.set(
                moveRot.x + mouseRot.x,
                moveRot.y + mouseRot.y,
                moveRot.z + mouseRot.z
            )
        }
    }

    _updateCamMouse()
    {
        const pos = this._camData.mousePos
        //const rot = this._camData.mouseRot

        const mX = this._mouseX
        const mY = this._mouseY

        // const rotP = 0.5         // Rotation max in radian
        const posP = this._margin   // Position max in pixels
        const slow = 0.01           // Velocity of camera movments

        /*rot.x = ((0.5 - mY) * rotP - rot.x) * slow + rot.x
        rot.y = ((0.5 - mX) * rotP - rot.y) * slow + rot.y*/

        pos.x = ((mX - 0.5) * posP - pos.x) * slow + pos.x
        pos.y = ((0.5 - mY) * posP - pos.y) * slow + pos.y
    }

    dispose()
    {
        if (this._touch && window.DeviceOrientationEvent)
        {
            window.removeEventListener('deviceorientation', this._onOrientation)
        }

        window.removeEventListener('mousemove', this._onMouseMove)


        this._isLoadedCallback = () => { }

        if (this._scene)
        {
            while(this._scene.children.length > 0)
            {
                const child = this._scene.children[0]
                const mat = child.material

                if (mat)
                {
                    this._disposeMat(mat)
                }

                // child.dispose()
                this._scene.remove(child)
            }

            this._scene = null
        }

        this._disposeVideos()
    }

    initScroll( val )
    {
        const moveData = this._moveData

        moveData.prevScroll = val
        moveData.currentScroll = val
        moveData.currentValue = val
    }

    scroll( val = this._moveData.currentScroll )
    {
        const moveData = this._moveData
        const minVal = 0.01

        val = (val < minVal) ? minVal : (val > 1) ? 1 : val

        const { dist, offsetY, sceneH } = this._camData

        const minY = - (offsetY + this._margin)
        const maxY = offsetY - (sceneH - this._margin)
        const posY = val * (maxY - minY) + minY

        moveData.currentScroll = val


        // Camera position
        if (this._camera)
        {
            const pos = this._camData.scrollPos
            pos.y = posY
            pos.z = dist
        }

        this._frustrumCulling( posY )
    }


    /*
            ┌─────────────────────────────────────────────
            │
            │       EVENTS
            │
            └─────────────────────────────────────────────
    */

    _onMouseMove( { clientX, clientY } )
    {
        this._mouseX = clientX / this._w
        this._mouseY = clientY / this._h
    }

    _onOrientation( { alpha, beta, gamma } )
    {
        this._mouseX = 1 - (gamma + 90) / 180
        this._mouseY = 1 - (beta + 180) / 360
    }



    /*
            ┌─────────────────────────────────────────────
            │
            │       MATERIAL GENERAL
            │
            └─────────────────────────────────────────────
    */

    _getMat( tileData, size = [1, 1] )
    {
        let mat

        if (tileData.video !== null)
        {
            mat = this._getMatVideo(tileData, size)
        }
        else
        {
            mat = this._getMatImg(tileData)
        }

        return mat
    }

    _disposeMat( mat )
    {
        if (mat.map)
        {
            mat.map.dispose()
        }

        if (mat.uniforms)
        {
            if (mat.uniforms.diff1 && mat.uniforms.diff1.value)
            {
                mat.uniforms.diff1.value.dispose()
            }

            if (mat.uniforms.diff2 && mat.uniforms.diff2.value)
            {
                mat.uniforms.diff2.value.dispose()
            }
        }

        mat.dispose()
    }


    /*
            ┌─────────────────────────────────────────────
            │
            │       MATERIAL IMAGE
            │
            └─────────────────────────────────────────────
    */

    _changeMat( oldMat, tileData )
    {
        const mesh = tileData.mesh
        // mesh.map = oldMat.uniforms.diff2.value

        const newMat = new THREE.ShaderMaterial({
            uniforms: {
                map: { type: 'f', value: oldMat.uniforms.diff2.value }
            },
            vertexShader: BASIC_VERTEX_SHADER,
            fragmentShader: BASIC_FRAGMENT_SHADER,
            transparent: false,
            lights: false,
            fog: false
        })

        mesh.material = newMat
    }

    _getMatImg( tileData, onLoaded = null )
    {
        // isThumb: true,
        // const mesh = tileData.mesh
        const mat = new THREE.MeshBasicMaterial({
            // vertexShader: BASIC_VERTEX_SHADER,
            // fragmentShader: BASIC_FRAGMENT_SHADER,
            transparent: false,
            lights: false,
            fog: false
        })
        // mesh.material = mat

        this._addLoadItem()

        // mesh.map = oldMat.uniforms.diff2.value
        TEX_LOADER.load( tileData.img, (tex1) => {

            tex1.format = THREE.RGBFormat
            mat.map = tex1
            tileData.texture.push(tex1)
            this._rmLoadItem()

            mat.needsUpdate = true

            if (onLoaded)
            {
                onLoaded(mat)
            }
        })

        return mat
    }


    /*
            ┌─────────────────────────────────────────────
            │
            │       MATERIAL VIDEO
            │
            └─────────────────────────────────────────────
    */

    _getMatVideo( tileData, [width, height] )
    {
        // load img before video
        return this._getMatImg(tileData, mat => {

            const elmt = document.createElement( 'video' )
            // video.type = ' video/ogg codecs="theora, vorbis" '
            elmt.src = tileData.video
            elmt.load()
            elmt.play()
            elmt.addEventListener('ended', () => {
                elmt.currentTime = 0
                elmt.play()
            })

            const canvas = document.createElement( 'canvas' )
            canvas.width = width
            canvas.height = height

            const context = canvas.getContext( '2d' )
            context.fillStyle = '#FF7700'
            context.fillRect( 0, 0, canvas.width, canvas.height )

            const texture = new THREE.Texture( canvas )
            texture.minFilter = THREE.LinearFilter
            texture.magFilter = THREE.LinearFilter

            this._videoList.push({
                elmt,
                canvas,
                context,
                texture
            })

            /*var mat = new THREE.MeshBasicMaterial({
                map : texture,
                overdraw : true,
                side : THREE.DoubleSide
            })*/


            if (this._videoIndex == null)
            {
                this._videoIndex = 0
            }
            else
            {
                this._videoIndex++
            }

            let frame = 0
            const displayByFrame = Math.floor(60 / VIDEOS_FPS)
            const seed = this._videoIndex
            tileData.texture.push(texture)
            tileData.update = () => {

                if ( elmt.readyState === elmt.HAVE_ENOUGH_DATA
                     && (seed + frame) % displayByFrame === 0 )
                {
                    if (mat.map !== texture)
                    {
                        mat.map = texture
                    }

                    context.drawImage( elmt, 0, 0 )
                    texture.needsUpdate = true
                }
                frame++
            }
        })
    }

    _disposeVideos()
    {
        for (let i = 0, l = this._videoList.length; i < l; i++)
        {
            const data = this._videoList[i]

            const videoElmt = data.elmt
            videoElmt.pause()
            videoElmt.src = ''
            data.elmt.load()
        }
    }


    /*
            ┌─────────────────────────────────────────────
            │
            │       ENGINE
            │
            └─────────────────────────────────────────────
    */

    _initThree( canvas, width, height, video )
    {
        this._loadCounter = 0
        // this._meshList = []

        const camera = this._initCam(width, height)
        const renderer = new THREE.WebGLRenderer({
            canvas,
            premultipliedAlpha : false,
            stencil : false,
            depth : false
        })
        const scene = this._initScene()

        renderer.setSize(width, height)
        renderer.autoClear = false
        // renderer.gammaInput = true
        // renderer.gammaOutput = true
        renderer.precision = 'lowp'
        renderer.premultipliedAlpha = false
        renderer.stencil = false
        renderer.preserveDrawingBuffer = false
        renderer.depth = false
        renderer.setClearColor (0x1b1820, 1)
        scene.add(camera)

        this._camData.sceneH = this._addTiles(scene, video)

        this._camera = camera
        this._renderer = renderer
        this._scene = scene

        const composer = this._initComposer(renderer, scene, camera)
        this._composer = composer



        // intro animation
        this.initScroll(4)
        this.scroll(0)
        renderer.render(scene, camera)
    }

    _initComposer( renderer, scene, camera )
    {
        const composer = new THREE.EffectComposer( renderer )

        const renderPass = new THREE.RenderPass( scene, camera )
        composer.addPass( renderPass )

        const effectFilm = new THREE.FilmPass( 0.35, 0.025, 648 )
        effectFilm.renderToScreen = true
        composer.addPass( effectFilm )

        return composer
    }

    _initCam( width, height )
    {
        const fov = 45 // this._camData.fov
        const aspect = width / height
        const near = 0.1
        const far = 10000

        const camera = new THREE.PerspectiveCamera(
            fov,
            aspect,
            near,
            far
        )

        camera.position.z = 300

        return camera
    }


    /*
            ┌─────────────────────────────────────────────
            │
            │       OBJECTS 3D MOVE
            │
            └─────────────────────────────────────────────
    */

    _move( dt )
    {
        const { currentValue, currentScroll, prevScroll } = this._moveData
        let vel = (currentScroll - prevScroll) * 100 * 5
        vel = Math.min(Math.max(vel, -10), 10)


        const smooth = (vel < currentValue) ? 0.8 : 0.4 // velocity up or down
        const newValue = currentValue + (Math.abs(vel) - currentValue) * smooth * dt / 1000 // this._physicTween.update()



        // Camera rotation
        if (this._camera)
        {
            const rot = this._camData.moveRot
            const camRotX = -this.scrollVelocity * dt / 100
            rot.x += (camRotX - rot.x) / 50
        }


        // Tiles move
        const rot0 = [0,0,0]
        for (const tileData of this._tilesData)
        {
            const mesh = tileData.mesh

            if (tileData.visible)
            {
                mesh.position.set(...lerpArr(tileData.farPos, tileData.nearPos, newValue))
                mesh.rotation.set(...lerpArr(tileData.farRot, rot0, newValue))
            }
        }

        this._moveData.currentValue = newValue
        this._moveData.prevScroll = currentScroll
    }


    // Manual frustrum culling (improve performances)
    _frustrumCulling( posY )
    {
        const tilesData = this._tilesData
        for (const tileData of tilesData)
        {
            const dist = Math.abs(posY - tileData.nearPos[1])
            const mesh = tileData.mesh
            if (dist > 400)
            {
                if (tileData.visible)
                {
                    mesh.visible = false
                    mesh.matrixAutoUpdate = false
                    tileData.visible = false
                }
            }
            else
            {
                if (!tileData.visible)
                {
                    mesh.visible = true
                    mesh.matrixAutoUpdate = true
                    tileData.visible = true
                }
            }
        }
    }



    /*
            ┌─────────────────────────────────────────────
            │
            │       OBJECTS 3D CREATE
            │
            └─────────────────────────────────────────────
    */

    _initScene()
    {
        const scene = new THREE.Scene()
        scene.frustumCulled = false
        return scene
    }

    _addTiles( parent, video )
    {
        let y = 0
        // m = middle, t = top, b = bottom, l = left, r = right
        for(let i = 0, l = BLOCK_LIST.length; i < l; i++)
        {
            const block = BLOCK_LIST[i]
            switch(block.type)
            {
                case 1:
                {
                    this._addTile(
                        parent,
                        this._bk2Data(block.src, 0, y, 'mm', video)
                    )
                    y += GLOBAL_DATA.width / GLOBAL_DATA.imgXRatio
                    break
                }
                case 2:
                {
                    this._addTile(
                        parent,
                        this._bk2Data(block.src, 0, y, 'tl', video)
                    )
                    this._addTile(
                        parent,
                        this._bk2Data(block.src, 1, y, 'tr', video)
                    )
                    y += GLOBAL_DATA.width / (GLOBAL_DATA.imgXRatio * 2)
                    break
                }
                case 22:
                {
                    this._addTile(
                        parent,
                        this._bk2Data(block.src, 0, y, 'ml', video)
                    )
                    this._addTile(
                        parent,
                        this._bk2Data(block.src, 1, y, 'mr', video)
                    )
                    y += GLOBAL_DATA.width / GLOBAL_DATA.imgXRatio
                    break
                }
                case 21:
                {
                    this._addTile(
                        parent,
                        this._bk2Data(block.src, 0, y, 'tl', video)
                    )
                    this._addTile(
                        parent,
                        this._bk2Data(block.src, 1, y, 'bl', video)
                    )
                    this._addTile(
                        parent,
                        this._bk2Data(block.src, 2, y, 'mr', video)
                    )
                    y += GLOBAL_DATA.width / GLOBAL_DATA.imgXRatio
                    break
                }
                case 12:
                {
                    this._addTile(
                        parent,
                        this._bk2Data(block.src, 0, y, 'ml', video)
                    )
                    this._addTile(
                        parent,
                        this._bk2Data(block.src, 1, y, 'tr', video)
                    )
                    this._addTile(
                        parent,
                        this._bk2Data(block.src, 2, y, 'br', video)
                    )
                    y += GLOBAL_DATA.width / GLOBAL_DATA.imgXRatio
                    break
                }
            }
        }

        return y
    }

    _addTile( container, {thumb, img, src, video, x, y, w, h, vW, vH} )
    {
        const pos = [x, y, 0]

        const tileData = {

            // src
            thumb,
            img,
            video,

            // positions
            nearPos: pos,
            farPos: this._getFarPos( pos ),
            farRot: [
                this._rand(-0.2, 0.2),
                this._rand(-0.2, 0.2),
                this._rand(-0.05, 0.05)
            ],

            // global object
            mesh: null,
            texture: [],
            visible: false,
            update: null,

            /*isThumb: true,
            toThumb: () => {},
            toBig: () => {}*/
        }

        const mat = this._getMat(tileData, [vW, vH])

        const tile = new THREE.Mesh( this._getPlaneGeom(), mat);
        tile.frustumCulled = false
        tile.matrixAutoUpdate = false
        tile.visible = false
        tile.position.set(x, y, 0)
        tile.scale.set(w, h, 1)
        container.add(tile)

        tileData.mesh = tile
        this._tilesData.push(tileData)
    }

    _getFarPos( pos )
    {
        const [x, y, z] = pos
        const minZ = -50
        const maxZ = -500
        const offsetY = 100

        const farZ = this._rand( minZ, maxZ )

        return [
            this._rand( x + (x < 0 ? farZ : 0) , x - (x > 0 ? farZ : 0) ) ,
            y, // this._rand( y - offsetY, y + offsetY ),
            farZ
        ]
    }

    _rand( min, max )
    {
        return Math.random() * (max - min) + min
    }

    _addLoadItem()
    {
        this._loadCounter++
    }

    _rmLoadItem()
    {
        this._loadCounter--
        if (this._loadCounter <= 0)
        {
            this._isLoadedCallback()
        }
    }

    _getPlaneGeom()
    {
        if (this._planeGeom == undefined)
        {
            this._planeGeom = new THREE.PlaneBufferGeometry(1, 1, 1, 1)
        }

        return this._planeGeom
    }


    /*
            ┌─────────────────────────────────────────────
            │
            │       LAYOUT
            │
            └─────────────────────────────────────────────
    */

     _bk2Data( srcSet, num, posY, layerCode, hasVideo )
    {
        const isVideo = srcSet[num].length > 1
        const wDefault = GLOBAL_DATA.width / 2
        const hDefault = wDefault / GLOBAL_DATA.imgXRatio

        let x, y, w, h, vW, vH
        if (layerCode === 'mm')
        {
            x = 0
            y = hDefault
            w = wDefault * 2
            h = hDefault * 2
            vW = 1280
            vH = 720
        }
        else if (layerCode === 'ml' || layerCode === 'mr')
        {
            w = wDefault
            h = wDefault / GLOBAL_DATA.imgYRatio
            y = h / 2
            x = (layerCode === 'ml') ? (-w / 2) : (w / 2)
        }
        else
        {
            w = wDefault
            h = hDefault
            vW = 640
            vH = 360

            if (layerCode[0] === 't')
            {
                y = hDefault / 2
            }
            else if (layerCode[0] === 'b')
            {
                y = 3 * hDefault / 2
            }

            if (layerCode[1] === 'l')
            {
                x = -wDefault / 2
            }
            else if (layerCode[1] === 'r')
            {
                x = wDefault / 2
            }
        }

        return {
            x,
            y: -(y + posY),
            w,
            h,
            vW,
            vH,
            // thumb: srcSet[num][0],
            img: (isVideo ? srcSet[num][1] : srcSet[num][0]),
            video: ((isVideo && hasVideo) ? srcSet[num][0] : null),
        }
    }
}
